import { useEffect } from 'react';

export const useErrorLogger = (label: string, err: any) => {
  useEffect(() => {
    if (err) {
      console.error(label, err);
    }
  }, [label, err]);
};
